<template>
    <div class="tm-scope tm-profile">
        <div class="tm-container tm-container--text">
            <div class="tm-card tm-profile__head tm-reveal">
                <div class="d-flex align-items-center">
                    <label for="profile-upload" class="tm-profile__avatar-wrap">
                      <img v-if="previewImage" :src="previewImage" alt="Profile" class="tm-profile__avatar" />
                      <img v-else src="../assets/images/auth/profile.png" class="tm-profile__avatar" alt="">
                    </label>
                    <input id="profile-upload" type="file" accept="image/*" class="d-none" @change="handleFileUpload" />
                    <div class="ms-3">
                      <h5 v-if="username" class="mb-0">{{ username }}</h5>
                    </div>
                    <div class="ms-auto d-flex gap-2">
                        <label for="profile-upload" class="tm-btn-secondary">Upload new photo</label>
                    </div>
                </div>
            </div>

            <h3 class="tm-h3 tm-reveal">General information</h3>
            <div class="tm-card tm-reveal">
                <div class="tm-field-grid">
                    <div>
                        <label class="tm-field-label" for="profile-first-name">First name</label>
                        <input id="profile-first-name" type="text" class="tm-field" placeholder="Your first name" v-model="firstName">
                    </div>
                    <div>
                        <label class="tm-field-label" for="profile-last-name">Last name</label>
                        <input id="profile-last-name" type="text" class="tm-field" placeholder="Your last name" v-model="lastName">
                    </div>
                    <div>
                        <label class="tm-field-label" for="profile-username">User name</label>
                        <input id="profile-username" type="text" class="tm-field" placeholder="Your user name" v-model="username">
                    </div>
                    <div>
                        <label class="tm-field-label" for="profile-dob">Date of birth</label>
                        <input id="profile-dob" type="date" class="tm-field" v-model="dateOfBirth">
                    </div>
                    <div>
                        <label class="tm-field-label" for="profile-phone">Phone number</label>
                        <input id="profile-phone" type="tel" class="tm-field" placeholder="Your phone number" v-model="phoneNumber">
                    </div>
                    <div>
                        <label class="tm-field-label" for="profile-email">Email</label>
                        <input id="profile-email" type="text" class="tm-field" placeholder="Email" v-model="email">
                    </div>
                </div>
            </div>

            <h3 class="tm-h3 tm-reveal">Address</h3>
            <div class="tm-card tm-reveal">
                <div class="tm-field-grid">
                    <div>
                        <label class="tm-field-label" for="profile-country">Country</label>
                        <input id="profile-country" type="text" class="tm-field" placeholder="Your country" v-model="country">
                    </div>
                    <div>
                        <label class="tm-field-label" for="profile-postal-code">Postal code</label>
                        <input id="profile-postal-code" type="text" class="tm-field" placeholder="Your postal code" v-model="postalCode">
                    </div>
                    <div class="tm-field-grid__full">
                        <label class="tm-field-label" for="profile-address">Full address</label>
                        <input id="profile-address" type="text" class="tm-field" placeholder="Your address" v-model="address">
                    </div>
                </div>
            </div>

            <h3 class="tm-h3 tm-reveal">Password</h3>
            <div class="tm-card tm-reveal">
                <div class="tm-field-grid">
                    <div class="position-relative">
                        <label class="tm-field-label" for="password">Current password</label>
                        <input id="password" type="password" class="tm-field" placeholder="Your current password">
                        <FontAwesomeIcon v-if="!showPass" icon="fa-solid fa-eye-slash" class="tm-profile__eye" @click="view('password')"/>
                        <FontAwesomeIcon v-else icon="fa-solid fa-eye" class="tm-profile__eye" @click="view('password')"/>
                    </div>
                    <div class="position-relative">
                        <label class="tm-field-label" for="new_password">New password</label>
                        <input id="new_password" type="password" class="tm-field" placeholder="Your new password">
                        <FontAwesomeIcon v-if="!showNewPass" icon="fa-solid fa-eye-slash" class="tm-profile__eye" @click="view('new_password')"/>
                        <FontAwesomeIcon v-else icon="fa-solid fa-eye" class="tm-profile__eye" @click="view('new_password')"/>
                    </div>
                    <div class="position-relative">
                        <label class="tm-field-label" for="confirm_new_password">Confirm new password</label>
                        <input id="confirm_new_password" type="password" class="tm-field" placeholder="Confirm your new password">
                        <FontAwesomeIcon v-if="!showconfirmNewPass" icon="fa-solid fa-eye-slash" class="tm-profile__eye" @click="view('confirm_new_password')"/>
                        <FontAwesomeIcon v-else icon="fa-solid fa-eye" class="tm-profile__eye" @click="view('confirm_new_password')"/>
                    </div>
                </div>
                <button class="tm-btn-secondary mt-4" @click="edit()">Save new password</button>
            </div>

            <div v-if="saveError" class="text-danger text-end mt-3">{{ saveError }}</div>
            <div class="tm-profile__actions">
                <button class="tm-btn-secondary" @click="loadProfile()">Cancel</button>
                <button class="tm-btn-primary" :disabled="saving" @click="edit()">
                    <Spinner v-if="saving" :size="16" />
                    <span v-else>Save all changes</span>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { AuthApiService } from '@/services/AuthApiService';
import { UserInfoApiService } from '@/services/UserInfoApiService';
import Swal from 'sweetalert2';
import { defineComponent, onMounted, ref } from 'vue';
import {profile} from '../services/Store';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import Spinner from '@/components/Spinner.vue';

export default defineComponent({
    components:{FontAwesomeIcon, Spinner},
    setup() {
        library.add(faEyeSlash,faEye)
        const username = ref();
        const email = ref();
        const address = ref();
        const country = ref();
        const firstName = ref();
        const lastName = ref();
        const dateOfBirth = ref();
        const phoneNumber = ref();
        const postalCode = ref();
        const showNewPass = ref(false);
        const showPass = ref(false);
        const showconfirmNewPass = ref(false);
        const previewImage = ref(null); // برای پیش‌نمایش تصویر
        const selectedFile = ref(null); // ذخیره فایل آپلود شده
        const saving = ref(false);
        const saveError = ref('');

        function loadProfile() {
            UserInfoApiService.getUserInfo(localStorage.getItem('user_id')).then((res)=>{
                if (res.status==200) {
                  const info = res.data.user_info
                  email.value = info.email
                  username.value = info.username
                  country.value = info.country!='None' ? info.country : ''
                  address.value = info.address!='None' ? info.address : ''
                  firstName.value = info.first_name && info.first_name!='None' ? info.first_name : ''
                  lastName.value = info.last_name && info.last_name!='None' ? info.last_name : ''
                  dateOfBirth.value = info.date_of_birth && info.date_of_birth!='None' ? info.date_of_birth : ''
                  phoneNumber.value = info.phone_number && info.phone_number!='None' ? info.phone_number : ''
                  postalCode.value = info.postal_code && info.postal_code!='None' ? info.postal_code : ''
                }
            })
            AuthApiService.getProfile(localStorage.getItem('user_id')).then((res)=>{
              if (res.status==200) {
                previewImage.value = res.data.url
              }
            }).catch(()=>{})
        }

        onMounted(loadProfile)

        const handleFileUpload = (event) => {
            const file = event.target.files[0];
            if (file) {
                selectedFile.value = file;
                previewImage.value = URL.createObjectURL(file);
                uploadProfileImage()
            }
        };

        const uploadProfileImage = async () => {
            if (!selectedFile.value) return;

            const formData = new FormData();
            formData.append('file', selectedFile.value);

            AuthApiService.updateProfile(formData,localStorage.getItem('user_id')).then((res)=>{
                if (res.status==200) {
                    Swal.fire({
                        icon: "success",
                        title: "success",
                        text: "profile updated!"
                    });
                    localStorage.setItem('update',1)
                    profile.count = 1;
                }
            }).catch(()=>{
                Swal.fire({
                    icon: "error",
                    title: "error",
                    text: "Couldn't upload your photo. Please try again."
                });
            })
        };

        function edit() {
            saveError.value = ''
            saving.value = true
            let body = {
                'user_id': localStorage.getItem('user_id'),
                'user_name': username.value,
                'email':email.value,
                'country': country.value,
                'address': address.value,
                'first_name': firstName.value,
                'last_name': lastName.value,
                'date_of_birth': dateOfBirth.value,
                'phone_number': phoneNumber.value,
                'postal_code': postalCode.value
            }
            UserInfoApiService.editUserInfo(body).then((res)=>{
                if (res.status==200) {
                    Swal.fire({
                        title: "successful",
                        text: "user info edited",
                        icon: "success"
                    });
                }
            }).catch(()=>{
                saveError.value = "Couldn't save your changes. Please try again."
            }).finally(()=>{
                saving.value = false
            })
        }

        function view(id){
            if (id=='new_password') {
                showNewPass.value = !showNewPass.value;
                document.getElementById(id).type = showNewPass.value ? 'text' : 'password'
            }
            else if (id=='password'){
                showPass.value = !showPass.value;
                document.getElementById(id).type = showPass.value ? 'text' : 'password'
            }
            else if (id=='confirm_new_password'){
                showconfirmNewPass.value = !showconfirmNewPass.value;
                document.getElementById(id).type = showconfirmNewPass.value ? 'text' : 'password'
            }
        }

        return {
            username,
            email,
            address,
            country,
            firstName,
            lastName,
            dateOfBirth,
            phoneNumber,
            postalCode,
            previewImage,
            selectedFile,
            showNewPass,
            showPass,
            showconfirmNewPass,
            saving,
            saveError,
            view,
            edit,
            loadProfile,
            uploadProfileImage,
            handleFileUpload
        }
    }
})
</script>

<style lang="scss" scoped>
.tm-profile {
    padding: 64px 24px 96px;
}

.tm-h3 {
    font-weight: 600;
    color: var(--tm-ink);
    margin: 40px 0 16px;
}

.tm-profile__head {
    padding: 24px 28px;
}

.tm-profile__avatar-wrap {
    cursor: pointer;
    display: block;
}

.tm-profile__avatar {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid var(--tm-border);
}

.tm-field-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    @media (max-width: 575px) { grid-template-columns: 1fr; }
}

.tm-field-grid__full {
    grid-column: 1 / -1;
}

.tm-profile__eye {
    position: absolute;
    right: 12px;
    top: 38px;
    color: var(--tm-ink-muted);
    cursor: pointer;
}

.tm-profile__actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 32px;
}
</style>
